var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon-play",attrs:{"viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M6 4L23.1417 14.285C24.4364 15.0618 24.4364 16.9382 23.1417 17.715L6 28V4Z","fill":"currentColor"}})])}
var staticRenderFns = []

export { render, staticRenderFns }